import { create } from 'zustand';

interface RadixPortalState {
  closeAllPortals: boolean;
  setCloseAllPortals: (close: boolean) => void;
}

export const useRadixPortalStore = create<RadixPortalState>((set) => ({
  closeAllPortals: false,
  setCloseAllPortals: (close: boolean) => set({ closeAllPortals: close }),
}));
